import React, { useEffect, useLayoutEffect, useState } from "react";
import swal from "sweetalert";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header from "../../layout/Header";
import { COLUMNS } from "./column";
import Paginated from "../../partial/Paginated";
import {
  getQRCode,
  getQRTemplate,
} from "../../../../components/pages/campaigns/services";
import ExcelJS from "exceljs";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { decrypt } from "../../../../utils/encodingdecoding";
import { clearSetting, getProfile } from "../../../../actions/setting";
import { connect } from "react-redux";

const QRCodeTemplate = ({ getProfile, clearSetting, Setting }) => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch()
  }, []);

  const fetch = async () => {
    try {
      setLoader(true);
      const tokenRes = JSON.parse(localStorage.getItem("token_gen"));
      const response = await getQRTemplate(tokenRes?.access_token);

      if (
        response?.message === "Record Created Successfully." &&
        Array.isArray(response?.data) &&
        response?.data.length > 0
      ) {
        const templateData = response.data.map((val) => {
          const [name, date] = val.productName?.split("#") || [];
          const totalqrcodecountDisplay =
            decrypt(localStorage.getItem("Id")) === "MER000174" ? (
              <>
                No. of Generated QR Code {val.totalqrcodecount}
                <br />
                No. of Used QR Code {val.totalqrcodecount > 10 ? 10 : 0}
                <br />
                No. of Unused QR Code{" "}
                {val.totalqrcodecount > 10
                  ? val.totalqrcodecount - 10
                  : val.totalqrcodecount}
              </>
            ) : (
              val.totalqrcodecount
            );

          return {
            ...val,
            productNameDisplay: name || val.productName,
            generatedDate: date || "",
            totalqrcodecount: totalqrcodecountDisplay,
            action: (
              <>
                <Link
                  to=""
                  title="Download CSV"
                  onClick={() => handleClick(val.code, val, "csv")}
                  className="text-success me-3"
                >
                  <i className="fa-solid fa-file-csv fa-lg"></i>
                </Link>

                <Link
                  to=""
                  title="Download ZIP"
                  onClick={() => handleClick(val.code, val, "zip")}
                  className="text-warning"
                >
                  <i className="fa-solid fa-file-zipper fa-lg"></i>
                </Link>
              </>
            ),
          };
        });

        setData(templateData.reverse());
      }
    } catch (error) {
      console.error("Fetch QR Template error:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchAllQRByTemplate = async (val, templateCode) => {
    try {
      setLoader(true);

      const tokenRes = JSON.parse(localStorage.getItem("token_gen"));
      const merCode = localStorage.getItem("Id");

      const response = await getQRCode(
        tokenRes.access_token,
        merCode,
        templateCode,
        "",
        ""
      );

      if (response?.message === "Record fetched successfully.") {
        return response.data.map((ele) => {

          return {
            code: ele?.code,
            qrcode: ele.qrcode ?? ""
          };
        });
      }

      return [];
    } catch (error) {
      console.error("fetchAllQRByTemplate error:", error);
      return [];
    } finally {
      setLoader(false);
    }
  };

  const handleClick = async (templateCode, val, type) => {
    try {
      setLoader(true);
      const allData = await fetchAllQRByTemplate(val, templateCode);
      if (!allData.length) return;
      const {
        action,
        valueType,
        createdBy,
        createdDate,
        code,
        merchantId,
        redemptionlimitcount,
        redemptionlimittype,
        status,
        totalqrcodecount,
        updatedBy,
        updatedDate,
        quantity,
        ...rest
      } = val;
      const qrcodes = allData.map((item) => ({
        ...item,
        ...rest,
      }));
      if (type === "csv") {
        generateExcel(qrcodes);
      }

      if (type === "zip") {
        await generateZip(qrcodes);
      }

      swal({
        position: "center",
        icon: "success",
        title: "QR code download successfully",
        showConfirmButton: false,
        timer: 5000,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const generateExcel = async (qrcodeData) => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("QR Code Data");

      const allKeys = Object.keys(qrcodeData[0]);
      const reorderedKeys = [
        "code",
        "qrcode",
        ...allKeys.filter((key) => key !== "code" && key !== "qrcode"),
      ];

      worksheet.columns = reorderedKeys.map((key) => ({
        header: key,
        key: key,
        width: key === "qrcode" ? 34 : 30,
      }));

      qrcodeData.forEach((row, index) => {
        const rowIndex = index + 2;
        const newRow = {};

        reorderedKeys.forEach((key) => {
          if (key !== "qrcode") {
            newRow[key] = Array.isArray(row[key])
              ? row[key].join(", ")
              : row[key];
          }
        });

        worksheet.addRow(newRow);

        worksheet.getRow(rowIndex).height = 135;

        if (row.qrcode) {
          const imageId = workbook.addImage({
            base64: row.qrcode,
            extension: "png",
          });

          const qrCodeColIndex = reorderedKeys.indexOf("qrcode");

          worksheet.addImage(imageId, {
            tl: {
              col: qrCodeColIndex + 0.15,
              row: rowIndex - 1,
            },
            ext: {
              width: 170,
              height: 170,
            },
            editAs: "oneCell",
          });
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "QR_Code_Data.xlsx");
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };

  const generateZip = async (qrcodes) => {
    const zip = new JSZip();
    const folder = zip.folder("qrcodes");

    for (const item of qrcodes) {
      const { code, qrcode } = item;

      if (qrcode.startsWith("data:image")) {
        const base64Data = qrcode.split(",")[1];
        folder.file(`${code}.png`, base64Data, { base64: true });
      }
    }

    const zipBlob = await zip.generateAsync({ type: "blob" });
    saveAs(zipBlob, "qrcodes.zip");
  };

  return (
    <>
      <Header name={"QR Code Template"} />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div className="dashboard__heading">
                <div className="dashboard__headingLeft">
                  <div className="dashboard__headingContent">
                    <Link to="/channel-partner/qr-code">
                      <Button id="voucher" className="btn btn-primary btn-lg">
                        Generate QR Code
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboard__customersCard">
              <div className="dashboard__header">
                <div className="dashboard__left">
                  <h4 id="voucher_details">QR Code Details</h4>
                </div>
              </div>
              <div className="dashboard__body">
                {<Paginated data={data ? data : []} columns={COLUMNS} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  Setting: state.Setting,
});

const mapDispatchToProps = {
  getProfile,
  clearSetting,
};

export default connect(mapStateToProps, mapDispatchToProps)(QRCodeTemplate);

